"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmperorsRegenerationAbilityHandler = exports.EmperorsRegenerationActorAbilityFactory = exports.EmperorsRegenerationAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const core_1 = require("../../core/effects/core");
const Duration_1 = require("../../core/Duration");
const EventType_1 = require("../../core/events/EventType");
const Schedule_1 = require("../../core/Schedule");
class EmperorsRegenerationAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.EmperorsRegeneration;
        this.__typeName = "EmperorsRegeneration";
    }
}
exports.EmperorsRegenerationAbilityArgs = EmperorsRegenerationAbilityArgs;
let EmperorsRegenerationActorAbilityFactory = class EmperorsRegenerationActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("EmperorsRegeneration", "Self", 4);
    }
};
EmperorsRegenerationActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("EmperorsRegeneration")
], EmperorsRegenerationActorAbilityFactory);
exports.EmperorsRegenerationActorAbilityFactory = EmperorsRegenerationActorAbilityFactory;
let EmperorsRegenerationAbilityHandler = class EmperorsRegenerationAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        container.applyAbilityAnimation({
            sequence,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            animatedId: ability.invokerId,
            onAnimated: sequence => {
                container.applyBuff({
                    sequence,
                    creatorId: ability.invokerId,
                    targetId: ability.invokerId,
                    duration: Duration_1.Duration.Turns(6),
                    effect: new core_1.LinkedEventHandlerEffectArgs("Emperor's Regeneration", "Heals all allies at the start of turn", false, container.registerEventHandlerScript(ability.invokerId, EventType_1.EventType.TurnStarted, Schedule_1.Schedule.Unlimited, "ApplyEffects_OnEvent", {
                        target: Target_1.Target.AllAllies,
                        effects: [{
                                duration: Duration_1.Duration.Instant,
                                effect: new core_1.HoTHealingEffectArgs("EmperorsRegeneration", container.getLevel(ability.invokerId) * 10, 100)
                            }]
                    }))
                });
            }
        });
    }
};
EmperorsRegenerationAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.EmperorsRegeneration)
], EmperorsRegenerationAbilityHandler);
exports.EmperorsRegenerationAbilityHandler = EmperorsRegenerationAbilityHandler;
